/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Port } from './Port';
import {
    PortFromJSON,
    PortFromJSONTyped,
    PortToJSON,
    PortToJSONTyped,
} from './Port';

/**
 * 
 * @export
 * @interface Segment
 */
export interface Segment {
    /**
     * 
     * @type {Port}
     * @memberof Segment
     */
    port?: Port;
    /**
     * The date of this segment
     * @type {string}
     * @memberof Segment
     */
    date?: string;
    /**
     * The datetime of arrival. Null if the ship does not depart on the current date
     * @type {string}
     * @memberof Segment
     */
    arrivalDateTime?: string;
    /**
     * The datetime of departure. Null if the ship does not depart on the current date
     * @type {string}
     * @memberof Segment
     */
    departureDateTime?: string;
}

/**
 * Check if a given object implements the Segment interface.
 */
export function instanceOfSegment(value: object): value is Segment {
    return true;
}

export function SegmentFromJSON(json: any): Segment {
    return SegmentFromJSONTyped(json, false);
}

export function SegmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Segment {
    if (json == null) {
        return json;
    }
    return {
        
        'port': json['port'] == null ? undefined : PortFromJSON(json['port']),
        'date': json['date'] == null ? undefined : json['date'],
        'arrivalDateTime': json['arrivalDateTime'] == null ? undefined : json['arrivalDateTime'],
        'departureDateTime': json['departureDateTime'] == null ? undefined : json['departureDateTime'],
    };
}

export function SegmentToJSON(json: any): Segment {
    return SegmentToJSONTyped(json, false);
}

export function SegmentToJSONTyped(value?: Segment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'port': PortToJSON(value['port']),
        'date': value['date'],
        'arrivalDateTime': value['arrivalDateTime'],
        'departureDateTime': value['departureDateTime'],
    };
}

